import gql from 'graphql-tag';

import roomFields from '@/queries/fields/roomFields';
import lightFields from '@/queries/fields/lightFields';
import scheduledEventsFields from '@/queries/fields/scheduledEventsFields';
import invitationsFields from '@/queries/fields/invitationsFields';
import memberFields from '@/queries/fields/memberFields';
import scenesFields from '@/queries/fields/scenesFields';
import accessoryFields from '@/queries/fields/accessoryFields';
import groupFields from '@/queries/fields/groupFields';
import floorPlanFields from '@/queries/fields/floorPlanFields';
import { rhythmFields } from '@/queries/fields/RhythmFields';
import featuresActiveUntilFields from '@/queries/fields/featuresActiveUntilFields';

const floorFields = gql`
  fragment floorFields on Floor {
    id
    name
    displayOrder
    floorPlan {
      ...floorPlanFields
    }
    rooms {
      ...roomFields
    }
    groups {
      ...groupFields
    }
    lights {
      ...lightFields
    }
    scheduledEvents {
      ...scheduledEventsFields
    }
    members {
      ...memberFields
    }
    invitations {
      ...invitationsFields
    }
    scenes {
      ...scenesFields
    }
    accessories {
      ...accessoryFields
    }
    includesSensors
    rhythms {
      ...rhythmFields
    }
    featuresActiveUntil {
      ...featuresActiveUntilFields
    }
  }
  ${roomFields}
  ${lightFields}
  ${groupFields}
  ${scheduledEventsFields}
  ${invitationsFields}
  ${memberFields}
  ${scenesFields}
  ${accessoryFields}
  ${floorPlanFields}
  ${rhythmFields}
  ${featuresActiveUntilFields}
`;

export default floorFields;
